<template>
<div>
    <div class="form-container ou-donation-form ja-ou-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <JaAmountSelector />
                <FormSection title="Your Information">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow> 
                    <DonorAddress />

                </FormSection>  
                                    <div class="ja-gift">
                <FormSection title="Recipient's Information">
                      <div class="ja-gift-container">
                        <FormRow inline>
                          <FormCol :flex="2" field="custom.recipientFirstName" />
                          <FormCol :flex="2" field="custom.recipientLastName" />
                        </FormRow>
                        <FormRow inline>
                          <FormCol field="custom.recipientStreet" :flex="2" />
                          <FormCol field="custom.recipientStreet2" :flex="2" />
                        </FormRow>
                        <FormRow inline>
                          <FormCol field="custom.recipientCountry" :flex="1"><CountrySelector /></FormCol>
                          <FormCol field="custom.recipientCity" :flex="1" />
                          <FormCol field="custom.recipientState" :flex="1"
                            ><StateSelector :country="getValue('custom.recipientCountry')"
                          /></FormCol>
                          <FormCol field="custom.recipientZip" :flex="1" />
                        </FormRow>
                        <FormRow inline>
                          <FormCol field="custom.recipientEmail" />
                          <FormCol field="custom.recipientPhone" />
                        </FormRow>
                      </div>

                    <div class="total__section__con" v-if="form.amount">   
                  <div class="total__section">
                      <strong>Total</strong>
                      <div class="total__section__opt">
                        <span v-if="getValue('custom.Notes')">{{ getValue('custom.Notes') }}</span>
                        <strong><MoneyFormat
                        class="amount"
                        :value="tamount"
                        :currencyCode="form.currency"
                      /></strong>
                    </div>
                  </div>
                </div> 
                    </FormSection>
                                      </div>

  
                <FormSection title="Payment Details">
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false"/>
                    </FormRow>             
                </FormSection>                
                <FormSection title="" last>
                    <FormRow>
                      <FormLabel class="control-label">
                        <div style="padding-bottom:7px;">How did you hear about us?</div>
        
          <FormSelect field="custom.hearAboutUs" style="flex: 1; margin-right: 10px">
            <option :value="null">Select an option</option>
            <option value="instagram">Instagram</option>
            <option value="facebook">Facebook</option>
            <option value="x">X (Twitter)</option>
            <option value="whatsapp">WhatsApp</option>
            <option value="tiktok">TikTok</option>
            <option value="google">Google</option>
            <option value="print-magazine">Print Magazine</option>
            <option value="friend">Friend</option>
            <option value="family-member">Family Member</option>
            <option value="other">Other</option>
          </FormSelect>
        </FormLabel>
        </FormRow>
        <ErrorLabel field="custom.hearAboutUs" />                
                  <FormRow>
                      <NewsletterSubscribe text="Sign me up for Jewish Action’s monthly newsletter" />
                </FormRow>    
                </FormSection>
                    <PaymentButton :showAmount="false" btnText="Subscribe to Jewish Action Magazine"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { computed, defineComponent, ref, watch } from "vue";
import { usePaymentForm } from '~/shared/use-payment-form'
import JaAmountSelector from './components/amount-selector.vue'
import MoneyFormat from "vue-money-format";

export default defineComponent({
      components: {
    JaAmountSelector,
    MoneyFormat
  },
  setup(props) {
    const { getValue, setValue, form } = usePaymentForm();


      setValue('custom.isGift', 'true');


    const tamount = computed(() => {
      //@ts-ignore
      let calculatedAmount = ['wire', 'check'].includes(form.value.gateway)
      ? +form.value.amount!
      : form.value.handleProcessing
        ? Math.round((+form.value.amount! + +form.value.amount! * 0.025) * 100) / 100
        : +form.value.amount!;
      
      if (form.value.periodMonths && form.value.dayOfMonth) {
      calculatedAmount *= +form.value.periodMonths;
      }

      return calculatedAmount;
    });
    return {
      form,
      tamount,
      getValue,
      setValue,
    }
  },
})
</script>
<style scoped lang="scss">

::v-deep h2 {
color: var(--Grayscale-Ash, #0E1622);
margin-top: 0px;
margin-bottom: 16px;
font-family: "Oswald";
font-size: 16px;
font-style: normal;
font-weight: 600;
line-height: 18px; /* 112.5% */
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
label,
::v-deep label {
  font-size: .85em;
  color: #333;
}

.form-container.ou-donation-form.ja-ou-form{
    margin: 10px auto 0px !important;
    box-shadow: none !important;
}
.subscribe__btn {
    display: flex;
    background: #1DA1F2;
    color: white;
    margin-bottom: 20px;
    align-items: center;
    padding: 8px 12px;
    border-radius: 6px;
    font-weight: 600;
    gap: 7px;
    cursor:pointer;
    transition: all 0.3s ease-in-out;
    justify-content: center;
}
.subscribe__btn:hover{
      background: #004c7b;
    }
.subscribe__btn svg {
    height: 28px;
}
.subscribe__btn.checked{
      background: #f2f6fd;
    color: #595c5f;
    }

.subscribe__btn.checked svg {
    fill: #595c5f !important;
}

.total__section {
    display: flex;
    max-width: 100%;
    padding: 16px;
    flex-flow: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    border-radius: 2px;
    background: var(--Secondary-Light, #FFF9ED);
}

.total__section strong {
    color: var(--Grayscale-Ash, #0E1622);

/* Desktop/Headline/H7 */
    font-family: "Oswald";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px; /* 128.571% */
}

.total__section__opt {
    color: var(--Secondary-Default, #BD8E5C);
    display: flex;
    gap: 8px;
    align-items: center;
/* Desktop/Text/Label */
    font-family: "Merriweather";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
}

.ja-gift {
  margin-top: 20px;
      padding-top: 12px;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #efefef;
}
.ja-gift-container {
  margin-top: 30px;
}

.total__section__con {
margin-top: 30px;
}
</style>

